import React from 'react';

import { useNavigate } from "react-router-dom";

import styles from "./Footer.module.css";
import FooterLogo from './FooterLogo';

interface AdminFooterProps {
	onHandleSignOut: () => void;
}

const AdminFooter: React.FC<AdminFooterProps> = ({ onHandleSignOut }) => {
	const navigate = useNavigate();

	return (
		<footer className={`${styles.footer} bg-newTheme-spruce py-12`}>
			<div className={`${styles.footerContainer} px-4 sm:px-6 xl:px-0`}>
				<div className="grid grid-cols-1 lg:grid-cols-3 gap-8 items-start">
					{/* Brand */}
					<div className="flex flex-col items-center lg:items-start space-y-4">
						<div className="flex items-center space-x-2">
							<div className={styles.footerLogo}>
								<FooterLogo />
							</div>
						</div>
						<p className="font-karla text-center lg:text-left">
							Connecting families with certified doulas for personalized birth
							support.
						</p>
					</div>

					{/* Quick Links */}
					<div className="grid grid-cols-2 gap-4 text-center lg:text-left">
						<div className="space-y-3">
							<h3 className="font-semibold text-white font-karla uppercase">
								Get Started
							</h3>
							<ul className="space-y-2">
								<li>
									<button
										onClick={() => navigate("/search-doulas")}
										className="text-white font-karla transition-colors"
									>
										Search Doulas
									</button>
								</li>
								<li>
									<button
										onClick={() => navigate("/login")}
										className="text-white font-karla transition-colors"
									>
										My Portal
									</button>
								</li>
								<li>
									<button
										onClick={onHandleSignOut}
										className="text-white font-karla transition-colors"
									>
										Sign Out
									</button>

								</li>
							</ul>
						</div>
					</div>

					{/* Copyright and Legal Links */}
					<div className="text-center self-center lg:text-right">
						<p className="font-karla">&copy; {new Date().getFullYear()} Gaia</p>
						<p className="font-karla text-sm mt-1">
							All rights reserved.
						</p>
						<div className="flex flex-col lg:flex-row lg:justify-end items-center gap-4 mt-4">
							<button
								onClick={() => navigate("/privacy")}
								className="font-karla text-sm transition-colors underline"
							>
								Privacy Policy
							</button>
							<button
								onClick={() => navigate("/terms")}
								className="font-karla text-sm transition-colors underline"
							>
								Terms of Service
							</button>
						</div>
					</div>
				</div>
			</div>
		</footer >
	)
};

export default AdminFooter;